function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import { Button } from '@domain-group/fe-blueprint-ui/button';
import { Body } from '@domain-group/fe-blueprint-ui/typography';
import { MapIcon } from '@domain-group/fe-co-icon';
import { usePageViewEvent, useSendEvent } from '@domain-group/fe-co-analytics';
import * as styles from './no-results.style';
import { PropertyAlertButton } from '../property-alert-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NoResults = _ref => {
  var _ref$resultCount = _ref.resultCount,
    resultCount = _ref$resultCount === void 0 ? 0 : _ref$resultCount,
    propertyAlertProps = _ref.propertyAlertProps,
    _ref$canExpandSearch = _ref.canExpandSearch,
    canExpandSearch = _ref$canExpandSearch === void 0 ? false : _ref$canExpandSearch,
    onIncludeSurroundingSuburbs = _ref.onIncludeSurroundingSuburbs;
  usePageViewEvent({
    name: 'show-no-results'
  });
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleIncludeSurroundingSuburbs = () => {
    sendEvent('click-include-surrounding-areas');
    onIncludeSurroundingSuburbs === null || onIncludeSurroundingSuburbs === void 0 ? void 0 : onIncludeSurroundingSuburbs();
  };
  return ___EmotionJSX(Stack, {
    css: styles.noResults,
    vertical: true,
    horizontalAlign: "stretch",
    padding: {
      compact: ['xl', 'l'],
      regular: ['xl', 'none']
    },
    gap: "l"
  }, ___EmotionJSX(Stack, {
    horizontalAlign: "center",
    vertical: true
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/no-results-new_d3df8d6f.png",
    alt: ""
  }), ___EmotionJSX(Stack, {
    vertical: true,
    horizontalAlign: "center",
    gap: "xxs"
  }, ___EmotionJSX("h3", {
    css: styles.noResultsHeading
  }, ___EmotionJSX("span", {
    css: styles.noResultsHeadingText
  }, "No ", resultCount > 0 ? 'more' : '', " matching"), ' ', ___EmotionJSX("span", {
    css: styles.noResultsHeadingText
  }, "properties right now")), ___EmotionJSX(Body, null, "Try adjusting your filters or set an alert for new matches - new properties are added every day!"))), ___EmotionJSX(Stack, {
    vertical: {
      compact: true,
      regular: false
    },
    verticalAlign: "center",
    horizontalAlign: {
      compact: 'stretch',
      regular: 'center'
    },
    gap: "s"
  }, ___EmotionJSX(PropertyAlertButton, _extends({
    css: styles.propertyAlertButton
  }, propertyAlertProps, {
    appearance: "no-results"
  })), canExpandSearch && ___EmotionJSX(Button, {
    appearance: "lowlight",
    css: styles.nearbyButton,
    icon: ___EmotionJSX(MapIcon, null),
    onClick: handleIncludeSurroundingSuburbs
  }, "Include surrounding areas")));
};